module.exports = __webpack_public_path__ + "img/remove-false-block.8107378b.png";